"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextFromProps = exports.getDropOptions = void 0;
var getTextFromProps = exports.getTextFromProps = function getTextFromProps(label, readingNotes) {
  var labelCode = label.split('.').pop() || '';
  if (labelCode !== '') {
    var readingNotesObjects = Object.entries(readingNotes);
    var searchedReadingNote = readingNotesObjects.find(function (readingNote) {
      return readingNote[0].replace(/_/g, '').toLowerCase() === labelCode.toLowerCase();
    });
    if (searchedReadingNote) {
      return searchedReadingNote[1];
    }
  }
  return '';
};
var getDropOptions = exports.getDropOptions = function getDropOptions(reasons, readingNotes, firstDropdownOptionText) {
  if (reasons) {
    var dropOptions = [{
      content: firstDropdownOptionText,
      value: 'first_option',
      disabled: true
    }];
    reasons.map(function (readingNote) {
      return dropOptions.push({
        content: getTextFromProps("".concat(readingNote.messageCode), readingNotes),
        value: readingNote.number,
        disabled: false
      });
    });
    return dropOptions;
  }
  return [];
};